
const PROD_DOMAIN = 'https://app-v2-api.mlj130.com';//'https://app-v2-api.mlj130.com';

const DEVELOP_DOMAIN = 'https://component-activity-backend-go.io.mlj162.com';

const DOMAIN = process.env.PREACT_APP_ENV === 'development' ?  DEVELOP_DOMAIN  : PROD_DOMAIN;


const DOWNLOAD_URL = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.maliujia.pinxb&channel=0002160650432d595942&fromcase=60001&android_schema=pinxb:app'
export {
  DOMAIN,
  DOWNLOAD_URL
}